export const PRIVACY_POLICY = '/privacy_policy';
export const HOME = '/';
export const WALL = '/wall';
export const ABOUT = '/about';
export const MICROSOFT = '/microsoft';
export const APPLE = '/apple';
export const LINUX = '/linux';
export const ANDROID = '/android';
export const SUPPORT = '/support';
export const ENCLOCK_MICROSOFT_INSTALL = 'https://www.microsoft.com/en-us/p/enclock/9pm1p88w4ngn';
export const ENCLOCK_ANDROID_INSTALL = 'https://play.google.com/store/apps/details?id=com.myenclock.enclock';
export const ENCLOCK_LINUX_INSTALL = 'https://snapcraft.io/enclock';
export const ENCLOCK_MACOS_INSTALL = 'https://apps.apple.com/us/app/enclock/id1594651371';
export const ENCLOCK_INSTAGRAM_HOME = 'https://www.instagram.com/enc.lock/';